export function useClearFilters(
    categoriesStore,
    regionsStore,
    facetsStore,
    queryParamsStore,
    locationsStore,
    datesStore
) {
    categoriesStore.setChosenTopLevelCategory('');
    categoriesStore.uncheckAllCategories();
    regionsStore.setChosenRegion('');
    locationsStore.updateSelectedLocations([]);
    facetsStore.uncheckAllFacets();
    datesStore.updateDate('startDate', '');
    datesStore.updateDate('endDate', '');

    queryParamsStore.resetParamArray('facets');
    queryParamsStore.resetParamArray('places');

    queryParamsStore.updateParamString('bounds', null);
    queryParamsStore.updateParamString('startDate', null);
    queryParamsStore.updateParamString('endDate', null);
    queryParamsStore.updateParamString('keywords', null);

}
